module.exports = __webpack_public_path__ + "static/media/lora_modbus_en.50a80205.md";